import * as React from "react";
import { ReactComponent as Image404 } from "../../images/404.svg";
import PageWrapper from "../shared/PageWrapper";

const FileNotFound: React.FunctionComponent = () => {
  return (
    <PageWrapper>
      <Image404 data-cy="404svg" />
    </PageWrapper>
  );
};

export default FileNotFound;
